<div class="jhm-table-new-component" [class.mobile]="screenSize==='MOBILE'">
  @if (this.loading) {
    <div class="loading-indicator"><i class="fa-solid fa-spinner-third fa-spin"></i>Loading...</div>
  }
  @if (this.length === 0) {
    <div class="zero-state">
      @switch (zeroState) {
        <!-- the same view can be shown in more than one case -->
        @case ('inbox') {
          <div data-pw="zero-messages" class="no-inbox-messages">
            @if (searchQuery) {
              <div class="no-messages-search">
                You have no messages matching your search.
              </div>
            }
            @if (!searchQuery) {
              <div data-pw="zero-search" class="add-credits-or-contacts">
                @if (portalName === 'CIVILIAN') {
                  <div class="instruction">Complete the following steps before you get started.</div>
                }
                @if (portalName === 'INMATE') {
                  <div class="instruction">Complete the following step before you get started.</div>
                }
                <div data-pw="table-actions" class="actions">
                  @if (portalName === 'CIVILIAN') {
                    <div class="action-block">
                      <div class="circle-wrapper">
                        <div class="circle-with-icon">
                          <img src="./assets/images/cart-check.svg">
                        </div>
                      </div>
                      <div class="title">
                        Purchase Credit
                      </div>
                      <div class="description">
                        In order to send messages, you’ll first need to buy some credit.
                      </div>
                      <button class="jhm-button primary" (click)="showStripeModal = true; zeroStateActionClick.emit()">
                        <i class="fa-light fa-envelope-open-dollar"></i>
                        Purchase Credit
                      </button>
                    </div>
                  }
                  <div class="action-block">
                    <div class="circle-wrapper">
                      <div class="circle-with-icon">
                        <img src="./assets/images/user-add.svg">
                      </div>
                    </div>
                    <div class="title">
                      Add Contacts
                    </div>
                    @if (portalName === 'CIVILIAN') {
                      <div class="description">
                        Messages can only be sent to inmates you’ve added to your contacts. Add at least one contact before you begin.
                      </div>
                    }
                    @if (portalName === 'INMATE') {
                      <div class="description">
                        Messages can only be sent to users you’ve added to your contacts. Add at least one contact before you begin.
                      </div>
                    }
                    <a [routerLink]="['/contacts']" [queryParams]="{addContact: true}" (click)="zeroStateActionClick.emit()">
                      <button class="jhm-button">
                        <i class="fa-light fa-user-plus"></i>
                        Add Contacts
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              <div class="empty-inbox">
                <div class="wrapper">
                  <i class="fa-light fa-inbox fa-3x"></i>
                  <div class="title">
                    Your inbox is empty.
                  </div>
                  <div class="description">
                    Your inbox is where all your new and read messages go.
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @case ('sent') {
          <div class="no-sent">
            <div class="wrapper">
              <i class="fa-light fa-paper-plane-top fa-3x"></i>
              <div class="title">
                You have no sent messages.
              </div>
              <div class="description">
                You will see your sent messages here.
              </div>
            </div>
          </div>
        }
        @case ('drafts') {
          <div class="no-drafts">
            <div class="wrapper">
              <i class="fa-light fa-file fa-3x"></i>
              <div class="title">
                You have no drafts.
              </div>
              <div class="description">
                Drafts are messages you start writing but don’t discard or finish.
              </div>
            </div>
          </div>
        }
        @case ('contacts') {
          <div class="no-contacts">
            <div class="wrapper">
              <i class="fa-light fa-list fa-3x"></i>
              <div class="title">
                You have no contacts.
              </div>
              <div class="description">
                Contacts are inmates you can send messages and give credit to.
              </div>
              <button class="jhm-button primary" (click)="zeroStateActionClick.emit()">
                <img src="./assets/images/add-white.svg">
                Add Contact
              </button>
            </div>
          </div>
        }
        @case ('documents') {
          <div class="generic-zero-state">
            <div class="wrapper">
              <i class="fa-light fa-file-lock fa-3x"></i>
              <div class="title">
                You have no secure documents.
              </div>
              <div class="description">
                Secure documents are uploaded and encrypted for a specific inmate’s eyes only.
              </div>
              <button class="jhm-button primary" [routerLink]="['/secure-documents-upload']" (click)="zeroStateActionClick.emit()">
                <img src="./assets/images/add-white.svg">
                Add Document
              </button>
            </div>
          </div>
        }
        @case ('tags') {
          <div class="generic-zero-state">
            <div class="wrapper">
				      <i class="fa-light fa-tags fa-3x"></i>
              <div class="title">
                You have no tags.
              </div>
              <div class="description">
                Tags are used to connect letters and inmates together.
              </div>
              <button class="jhm-button primary" [routerLink]="['/tags/create']" (click)="zeroStateActionClick.emit()">
                <img src="./assets/images/add-white.svg">
                Add Tag
              </button>
            </div>
          </div>
        }
        @case ('rules') {
          <div class="generic-zero-state">
            <div class="wrapper">
				<i class="fa-light fa-list fa-3x"></i>
              <div class="title">
                You have no rules.
              </div>
              <div class="description">
                Tags are used to take action on letters, senders and recipients that fall within certain parameters.
              </div>
              <button class="jhm-button primary" [routerLink]="['/rules/create']" (click)="zeroStateActionClick.emit()">
                <img src="./assets/images/add-white.svg">
                Add Rule
              </button>
            </div>
          </div>
        }
        @case('staff-messages') {
            <div class="generic-zero-state">
              <div class="wrapper">
                  <i class="fa-light fa-envelope fa-3x"></i>
                <div class="title">
                  Your jurisdiction has no messages.
                </div>
                <div class="description">
                  This is where you will see all messages coming and leaving your jurisdiction.
                </div>
              </div>
            </div>
        }
        @case('inmates') {
            <div class="generic-zero-state">
              <div class="wrapper">
                  <i class="fa-light fa-user-group fa-3x"></i>
                <div class="title">
                  Your jurisdiction has no inmates.
                </div>
                <div class="description">
                  This is where you will view all inmates within your jurisdiction.
                </div>
                <button class="jhm-button primary" [routerLink]="['/inmates/create']" (click)="zeroStateActionClick.emit()">
                  <img src="./assets/images/add-white.svg">
                  Add Inmate
                </button>
              </div>
            </div>
        }
        @case('inmates-claim') {
            <div class="generic-zero-state">
              <div class="wrapper">
                  <i class="fa-light fa-user-group fa-3x"></i>
                <div class="title">
                  There are no inmates available to claim.
                </div>
                <div class="description">
                  This is where you will view inmates available to add to your jurisdiction when being transferred.
                </div>
              </div>
            </div>
        }
        <!--default case when there are no matches -->
        @default {
          <div>
            No matches found.
          </div>
        }
      }
    </div>
  }
  @else {
    <div class="form-item">
        <mat-form-field appearance="outline">
        <input class="table-search" matInput [(ngModel)]="searchQuery" placeholder="Search..." #input>
        </mat-form-field>
        <div class="custom-prefix"><i class="fa-light fa-search"></i></div>
    </div>
  }
  @if (this.length > 0) {
	<div class="table-and-paginator">
        <ag-grid-angular
            id=agGridTable
            class="ag-grid-table"
            [rowData]="rowData"
            [columnDefs]="repository?.colDefs"
            [gridOptions]="gridOptions"
            [quickFilterText]="searchQuery"
            [includeHiddenColumnsInQuickFilter]="true"
            (cellClicked)="clickedCell($event)"
            [getRowClass]="repository?.rowClassFunction"/>
	</div>
  }
</div>
@if (showStripeModal) {
  <jhm-stripe-purchase (exit)="showStripeModal = false;"></jhm-stripe-purchase>
}
